import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import Switch from 'antd-mobile/es/components/switch';
import bettingStrategyStore from '@mobx/stores/bettingStrategy-store';
import { observer } from 'mobx-react-lite';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
import { ContentBlockFragment, KolProfileFragment } from '@graphqlTypes/sitecore';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';
/** AllBettingStrategyBTN 开关  */
const AllBettingStrategyBTN = ({
    styles,
    contentBlock,
}: {
    styles?: string;
    contentBlock?: ContentBlockFragment | KolProfileFragment | null;
}) => {
    // const AllBettingStrategyBTN = ({ defaultInit }: { defaultInit?: boolean }) => {
    // console.log('content-BTN-------', content);
    const { t } = useTranslation('kol');
    const switchStyle = {
        '--checked-color': '#2655CC',
        '--adm-color-text-light-solid': '#fff',
        '--adm-color-border': '#8B8B8B',
        '--adm-color-weak': '#fff',
        '--height': '24px',
        fontSize: '11px',
    };

    return (
        <div className={cn('text-right ss:min-w-[185px]', styles)}>
            <span className='pr-2 text-sm text-black font-medium'>{t('AllBettingStrategy')}</span>
            <Switch
                className='!w-[63px]'
                uncheckedText={t('Off')}
                checkedText={t('On')}
                style={switchStyle}
                checked={bettingStrategyStore.bettingDefault}
                onChange={(v) => {
                    nonPageTracker(
                        {
                            eventID: v
                                ? TrackingEvent.BettingStrategyToggleOn
                                : TrackingEvent.BettingStrategyToggleOff,
                        },
                        { article: convertArticleInfo(contentBlock) }
                    );
                    bettingStrategyStore.setBettingValToApp(v);
                }}
            />
        </div>
    );
};

export default observer(AllBettingStrategyBTN);
